import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'

import { ContentBox } from '@offerzen/pinata-shame'

import LoadingSpinner from './LoadingSpinner'

import styles from './styles'

const ImportingResumeSpinner = ({ className }) => (
  <ContentBox size="default" theme="dark" className={cx(styles.wrapper, className)}>
    <LoadingSpinner />

    <p role="alert" aria-live="assertive" className={styles.text}>
      We&apos;re importing your information. This could take a few seconds.
    </p>
  </ContentBox>
)

ImportingResumeSpinner.propTypes = {
  className: PropTypes.string,
}

export default ImportingResumeSpinner
